(function () {
  if (window.__fellowCartAnalyticsLoaded) return;
  window.__fellowCartAnalyticsLoaded = true;

  var CART_DRAWER_ID = 'cart-drawer-dialog';
  var DEDUPE_WINDOW_MS = 1500;
  var dedupeCache = new Map();
  var previousCart = null;
  var pendingCartRequest = null;

  var CART_MUTATION_PATHS = new Set(['/cart/add.js', '/cart/add', '/cart/change.js', '/cart/change', '/cart/update.js', '/cart/update', '/cart/clear.js', '/cart/clear']);

  window.dataLayer = window.dataLayer || [];

  function getTemplateName() {
    var match = document.body && document.body.className.match(/template-([^\s]+)/);
    return match && match[1] ? match[1] : 'unknown';
  }

  function getCurrencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function toNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function centsToMoney(valueInCents) {
    return Math.round(toNumber(valueInCents)) / 100;
  }

  function getCurrencyFromCart(cart) {
    if (cart && typeof cart.currency === 'string' && cart.currency) {
      return cart.currency;
    }
    return getCurrencyCode();
  }

  /** GA4 allows one coupon string; multiple codes are joined with commas. */
  function couponFromCart(cart) {
    if (!cart) return undefined;
    var codes = cart.discount_codes;
    if (Array.isArray(codes) && codes.length) {
      var parts = [];
      for (var i = 0; i < codes.length; i++) {
        var entry = codes[i];
        var c = typeof entry === 'string' ? entry : entry && (entry.code || entry.discount_code);
        if (c) parts.push(String(c));
      }
      if (parts.length) return parts.join(',');
    }
    var apps = cart.cart_level_discount_applications;
    if (Array.isArray(apps) && apps.length) {
      var fromCodes = [];
      var otherTitles = [];
      for (var j = 0; j < apps.length; j++) {
        var a = apps[j];
        if (!a) continue;
        var type = a.type || a.discount_application_type;
        var label = a.code || a.title;
        if (!label) continue;
        if (type === 'discount_code') fromCodes.push(String(label));
        else otherTitles.push(String(label));
      }
      if (fromCodes.length) return fromCodes.join(',');
      if (otherTitles.length) return otherTitles.join(',');
    }
    return undefined;
  }

  function ecommerceValueFromCart(cart, lineSum) {
    if (cart && cart.total_price != null) {
      var tp = centsToMoney(cart.total_price);
      if (Number.isFinite(tp) && tp >= 0) {
        return Number(tp.toFixed(2));
      }
    }
    return Number(lineSum.toFixed(2));
  }

  function cleanObject(value) {
    if (Array.isArray(value)) {
      return value.map(cleanObject).filter(function (entry) {
        return entry !== undefined;
      });
    }
    if (value && typeof value === 'object') {
      var output = {};
      Object.keys(value).forEach(function (key) {
        var cleaned = cleanObject(value[key]);
        if (
          cleaned !== undefined &&
          cleaned !== null &&
          cleaned !== '' &&
          !(Array.isArray(cleaned) && cleaned.length === 0)
        ) {
          output[key] = cleaned;
        }
      });
      return output;
    }
    if (typeof value === 'number' && !Number.isFinite(value)) return undefined;
    return value;
  }

  function getVariantIdentifier(item) {
    var raw = item.variant_id || item.id || item.key || '';
    return String(raw);
  }

  function normalizeItem(rawItem, quantityOverride) {
    var quantity = quantityOverride || toNumber(rawItem.quantity) || 1;
    var unitPrice = centsToMoney(rawItem.final_price != null ? rawItem.final_price : rawItem.price);
    var itemId = rawItem.sku || getVariantIdentifier(rawItem) || String(rawItem.product_id || '');
    var productId = rawItem.product_id || rawItem.id || '';
    var variantTitle = rawItem.variant_title && rawItem.variant_title !== 'Default Title' ? rawItem.variant_title : undefined;

    return cleanObject({
      item_id: String(itemId),
      item_name: rawItem.product_title || rawItem.title || undefined,
      item_brand: rawItem.vendor || undefined,
      item_category: rawItem.product_type || undefined,
      item_variant: variantTitle,
      item_id_shopify: productId ? String(productId) : undefined,
      item_variant_id_shopify: getVariantIdentifier(rawItem),
      price: unitPrice,
      quantity: quantity
    });
  }

  function fingerprint(eventName, payload) {
    var ecommerce = payload && payload.ecommerce ? payload.ecommerce : {};
    var ids = Array.isArray(ecommerce.items)
      ? ecommerce.items.map(function (item) {
          return [item.item_id, item.quantity, item.price].join(':');
        })
      : [];
    return [eventName, ecommerce.value, ecommerce.currency, ids.join('|')].join('::');
  }

  function pushDataLayerEvent(eventName, payload) {
    var eventPayload = cleanObject(payload || {});
    var key = fingerprint(eventName, eventPayload);
    var now = Date.now();
    var previousTimestamp = dedupeCache.get(key);
    if (previousTimestamp && now - previousTimestamp < DEDUPE_WINDOW_MS) return false;
    dedupeCache.set(key, now);

    if (eventPayload.ecommerce) {
      window.dataLayer.push({ ecommerce: null });
    }
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          event_source: 'cart_analytics_defer',
          page_template: getTemplateName()
        },
        eventPayload
      )
    );
    return true;
  }

  function buildEcommerceFromCart(cart) {
    var items = Array.isArray(cart && cart.items)
      ? cart.items.map(function (item, index) {
          var row = normalizeItem(item);
          if (!row) return row;
          row.index = index;
          return row;
        })
      : [];
    var lineSum = items.reduce(function (total, item) {
      return total + toNumber(item.price) * toNumber(item.quantity || 1);
    }, 0);
    var value = ecommerceValueFromCart(cart, lineSum);
    var payload = {
      currency: getCurrencyFromCart(cart),
      value: value,
      items: items
    };
    var coupon = couponFromCart(cart);
    if (coupon) payload.coupon = coupon;
    return cleanObject(payload);
  }

  function cloneCart(cart) {
    if (!cart) return null;
    return JSON.parse(JSON.stringify(cart));
  }

  function getCart(force) {
    if (!force && pendingCartRequest) return pendingCartRequest;
    pendingCartRequest = fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to fetch cart.js');
        return response.json();
      })
      .then(function (cart) {
        previousCart = cart;
        return cart;
      })
      .catch(function () {
        return previousCart;
      })
      .finally(function () {
        pendingCartRequest = null;
      });
    return pendingCartRequest;
  }

  function keyCartLines(items) {
    var keyed = {};
    (items || []).forEach(function (item) {
      var key = getVariantIdentifier(item);
      if (!key) return;
      keyed[key] = item;
    });
    return keyed;
  }

  function emitCartDiffEvents(previous, current) {
    var prevByKey = keyCartLines(previous && previous.items);
    var currByKey = keyCartLines(current && current.items);
    var keys = new Set(Object.keys(prevByKey).concat(Object.keys(currByKey)));
    var addedItems = [];
    var removedItems = [];

    keys.forEach(function (key) {
      var prevItem = prevByKey[key];
      var currItem = currByKey[key];
      var previousQuantity = prevItem ? toNumber(prevItem.quantity) : 0;
      var currentQuantity = currItem ? toNumber(currItem.quantity) : 0;
      var quantityDelta = currentQuantity - previousQuantity;

      if (quantityDelta > 0 && currItem) {
        addedItems.push(normalizeItem(currItem, quantityDelta));
      } else if (quantityDelta < 0 && prevItem) {
        removedItems.push(normalizeItem(prevItem, Math.abs(quantityDelta)));
      }
    });

    if (addedItems.length) {
      var addValue = addedItems.reduce(function (total, item) {
        return total + toNumber(item.price) * toNumber(item.quantity || 1);
      }, 0);
      pushDataLayerEvent('add_to_cart', {
        ecommerce: {
          currency: getCurrencyCode(),
          value: Number(addValue.toFixed(2)),
          items: addedItems
        }
      });
    }

    if (removedItems.length) {
      var removeValue = removedItems.reduce(function (total, item) {
        return total + toNumber(item.price) * toNumber(item.quantity || 1);
      }, 0);
      pushDataLayerEvent('remove_from_cart', {
        ecommerce: {
          currency: getCurrencyCode(),
          value: Number(removeValue.toFixed(2)),
          items: removedItems
        }
      });
    }
  }

  function emitViewCart() {
    getCart(true).then(function (cart) {
      if (!cart) return;
      pushDataLayerEvent('view_cart', {
        ecommerce: buildEcommerceFromCart(cart),
        item_count: toNumber(cart.item_count)
      });
    });
  }

  function emitBeginCheckout(triggerSource) {
    // Push synchronously from the last known cart when possible so dataLayer fires before
    // full navigation can cancel an in-flight GET /cart.js (Checkout Extensibility / form POST).
    var snapshot = previousCart && cloneCart(previousCart);
    var hadSnapshot =
      snapshot && Array.isArray(snapshot.items) && snapshot.items.length > 0;
    if (hadSnapshot) {
      pushDataLayerEvent('begin_checkout', {
        checkout_trigger: triggerSource,
        item_count: toNumber(snapshot.item_count),
        ecommerce: buildEcommerceFromCart(snapshot)
      });
    }

    getCart(true).then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
      if (hadSnapshot) return;
      pushDataLayerEvent('begin_checkout', {
        checkout_trigger: triggerSource,
        item_count: toNumber(cart.item_count),
        ecommerce: buildEcommerceFromCart(cart)
      });
    });
  }

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (_error) {
      return '';
    }
  }

  function parseJsonSafe(response) {
    if (!response || !response.ok) return Promise.resolve(null);
    var contentType = response.headers.get('content-type') || '';
    if (contentType.indexOf('application/json') === -1 && contentType.indexOf('text/javascript') === -1) {
      return Promise.resolve(null);
    }
    return response
      .json()
      .then(function (data) {
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function handleCartMutation(pathname, beforeCartSnapshot, afterCartSnapshot) {
    if (!CART_MUTATION_PATHS.has(pathname)) return;
    emitCartDiffEvents(beforeCartSnapshot, afterCartSnapshot);
    previousCart = afterCartSnapshot || previousCart;
  }

  function interceptFetch() {
    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var requestMethod = (init && init.method) || (input && input.method) || 'GET';
      var pathname = normalizePath(requestUrl);
      var shouldTrackMutation = requestMethod.toUpperCase() !== 'GET' && CART_MUTATION_PATHS.has(pathname);
      var beforeSnapshotPromise = shouldTrackMutation
        ? getCart(false).then(function (cart) {
            return cloneCart(cart);
          })
        : Promise.resolve(null);

      return originalFetch.apply(window, arguments).then(function (response) {
        if (!shouldTrackMutation) return response;

        var clonedResponse = response.clone();
        Promise.all([beforeSnapshotPromise, parseJsonSafe(clonedResponse)])
          .then(function (results) {
            var beforeCartSnapshot = results[0];
            var afterCartSnapshot = results[1] || null;
            if (!afterCartSnapshot || !Array.isArray(afterCartSnapshot.items)) {
              return getCart(true).then(function (fallbackCart) {
                handleCartMutation(pathname, beforeCartSnapshot, fallbackCart);
              });
            }
            handleCartMutation(pathname, beforeCartSnapshot, afterCartSnapshot);
          })
          .catch(function () {
            // No-op: tracking should never break storefront requests.
          });

        return response;
      });
    };
  }

  function isCheckoutElement(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest('.cart-express-checkout')) return true;
    var checkoutSelector = 'a[href*="/checkout"],button[name="checkout"],input[name="checkout"],[data-checkout-button]';
    return !!target.closest(checkoutSelector);
  }

  function isCheckoutForm(form) {
    if (!form || !(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/checkout') !== -1;
  }

  function installUrlDrawerTracking() {
    var lastDrawerState = false;

    function checkDrawerState() {
      var params = new URLSearchParams(window.location.search);
      var isDrawerOpen = params.get('modals') === CART_DRAWER_ID;
      if (isDrawerOpen && !lastDrawerState) {
        emitViewCart();
      }
      lastDrawerState = isDrawerOpen;
    }

    var originalPushState = window.history.pushState;
    var originalReplaceState = window.history.replaceState;

    window.history.pushState = function () {
      var result = originalPushState.apply(window.history, arguments);
      checkDrawerState();
      return result;
    };

    window.history.replaceState = function () {
      var result = originalReplaceState.apply(window.history, arguments);
      checkDrawerState();
      return result;
    };

    window.addEventListener('popstate', checkDrawerState);
    checkDrawerState();
  }

  interceptFetch();
  installUrlDrawerTracking();

  document.addEventListener('modal-dialog::open', function (event) {
    var detail = event && event.detail;
    var modalId = typeof detail === 'string' ? detail : detail && (detail.id || detail.modalId);
    if (modalId === CART_DRAWER_ID) {
      emitViewCart();
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      if (isCheckoutElement(event.target)) {
        emitBeginCheckout('click');
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (isCheckoutForm(event.target)) {
        emitBeginCheckout('submit');
      }
    },
    true
  );

  // Prime cart snapshot for deterministic diffing.
  getCart(false);
})();
